var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgVpnKey = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "vpn-key_svg__a",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h24v24H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#vpn-key_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.706 19.778c-1.178 1.178-2.592 1.768-4.242 1.768s-3.064-.59-4.243-1.768c-1.178-1.179-1.768-2.593-1.768-4.243 0-1.65.59-3.064 1.768-4.242a5.77 5.77 0 0 1 2.723-1.556 6.179 6.179 0 0 1 3.075 0l6.223-6.223c.389-.389.86-.583 1.414-.584.554 0 1.026.195 1.414.584l1.415 1.415c.389.388.583.86.583 1.413 0 .554-.195 1.026-.583 1.415l.707.707c.389.389.583.86.584 1.414 0 .554-.195 1.026-.584 1.415l-1.415 1.414c-.388.389-.86.583-1.413.583a1.927 1.927 0 0 1-1.415-.583L16.242 12l-1.98 1.98a6.18 6.18 0 0 1 0 3.075 5.77 5.77 0 0 1-1.556 2.723Zm-1.414-1.414c.778-.778 1.164-1.641 1.159-2.59-.007-.949-.192-1.7-.558-2.254l4.349-4.349 2.121 2.122 1.415-1.415-2.122-2.121 1.414-1.414-1.414-1.414-7.177 7.177c-.554-.366-1.305-.551-2.254-.557-.949-.006-1.812.38-2.59 1.158-.777.777-1.166 1.72-1.166 2.828 0 1.108.389 2.05 1.166 2.829.778.777 1.721 1.166 2.829 1.166s2.05-.389 2.828-1.166Zm-1.414-1.415c.389-.389.583-.86.583-1.414 0-.554-.194-1.025-.583-1.414a1.927 1.927 0 0 0-1.415-.583c-.553 0-1.025.194-1.413.583-.39.389-.584.86-.584 1.413 0 .555.195 1.027.584 1.415.388.39.86.583 1.414.583.554 0 1.025-.194 1.414-.583Z",
  fill: "#9292AF"
}))));
export default SvgVpnKey;